import type { IBreadcrumbItem } from '@feathr/components';

interface IPrototypeSection {
  defaultPath: string;
  label: string;
}

/*
 * Build a two-level breadcrumb trail for a prototype page: the section's
 * landing page, then the current page. The `base` is the prototype's account-
 * scoped root, e.g. "/123/ia-prototype", obtained from
 * useRouteMatch('/:accountId/ia-prototype').
 */
export function buildPrototypeBreadcrumbs(
  base: string,
  section: IPrototypeSection,
  currentLabel: string,
  currentPath: string,
): IBreadcrumbItem[] {
  return [
    { key: 'section', label: section.label, path: `${base}${section.defaultPath}`, depth: 0 },
    { key: 'current', label: currentLabel, path: `${base}${currentPath}`, depth: 1 },
  ];
}
